import {Pipe, PipeTransform} from '@angular/core';

/**
 * Return a value for a provided key from an enum
 */
@Pipe({
    name: 'value'
})
export class ValuePipe implements PipeTransform {
    transform(value: any, values?: any): string {
        for (let index = 0; index < Object.keys(values).length; index++) {
            if (Object.keys(values)[index] === value) {
                return Object.values<string>(values)[index];
            }
        }
    }

}
